module.exports = __webpack_public_path__ + "img/19.aec3240.jpg";